import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApplicantSerializer } from '@app/model/serializer/applicant-serializer';
import { Applicant } from '@app/model/applicant';


@Injectable({ providedIn: 'root' })
export class ApplicantService extends ApiService<Applicant> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'applicant',
      new ApplicantSerializer());
  }
}
